export function Page404() {
  return (
    <div className="flex flex-col items-center justify-center text-center text-gray-800 dark:text-white">
      <span className="text-[5rem]">404</span>
      <span className="text-4xl">Page not found</span>
    </div>
  );
}
